import { graphql, useGqlContext } from '@search/gql-client/src';

import { useCallback } from 'react';

import type {
    OfferPhoneModal2Mutation$variables,
    OfferPhoneModal2Mutation$data
} from './__generated__/OfferPhoneModal2Mutation.graphql';

const OfferPhoneModal2Mutation = graphql`mutation OfferPhoneModal2Mutation(
    $subject: String!,
    $body: String!
) {
    createEmailCallbackProverka(subject: $subject, body: $body) {
        emailMessageId
    }
}`;

export const useOfferPhoneModal2Mutation = () => {
    const gql = useGqlContext();

    return useCallback(
        (
            vars: OfferPhoneModal2Mutation$variables,
            opts?: { signal?: AbortSignal }
        ) => gql.client<
            OfferPhoneModal2Mutation$variables,
            OfferPhoneModal2Mutation$data
        >(
            OfferPhoneModal2Mutation,
            vars,
            opts
        ),
        [ gql ]
    );
};
